import React from 'react';
import classNames from 'classnames';
import {SVGIcon} from '@homeaway/react-svg';
import {MAIL__24} from '@homeaway/svg-defs';

export class Inbox extends React.Component {
    get className() {
        return classNames(
            'site-header-nav__inbox',
            {[`${this.props.cssClass}`]: !!this.props.cssClass},
        );
    }


    render() {
        const {text} = this.props;

        return (
            <div className={this.className}>
                <SVGIcon inlineFlex markup={MAIL__24} /><span className="site-header-nav__icon-label">{text}</span>
            </div>
        );
    }
}
